/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@mui/styles';
import qs from 'query-string';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import PilgrimTopMenu from './PilgrimTopMenu';
import MobilePilgrimTopMenu from './PilgrimTopMenu/MobilePilgrimTopMenu';
import Sidenav from './Sidenav';
import StandaloneLayout from './StandaloneLayout/index';
import { fetchAppConfigs } from '../actions/AppConfigsActions';
import { updateLogonUser } from '../actions/AuthActions';
import { getSystemTranslations } from '../actions/TranslationActions';
import { getUserRolesAndRights } from '../actions/UserRolesActions';
import * as Urls from '../constants/Urls';
import { useWindowDimensions } from '../custom-hooks/useWindowDimensions';
import { getNetworkStatus } from '../form-designer/selectors/common.selectors';
import { getIsConfigMissed } from '../selectors/AppConfigsSelectors';
import { getIsRtlLanguage, selectIsLogonUserChanged } from '../selectors/AuthSelectors';
import { PAGE_LOAD_TIMER, startTimer } from '../utils/log';

const useStyles = makeStyles({
  default: {
    paddingLeft: 32,
    paddingTop: 28,
  },
  defaultRtl: {
    paddingRight: 32,
    paddingTop: 28,
  },
  noNavs: {
    height: '100%',
    marginLeft: 0,
  },
  mobile: {
    paddingLeft: 0,
    paddingTop: 32,
  },
});

export let pageLoadChecked = false;

export function setPageLoad(value) {
  pageLoadChecked = value;
}

const Layout = ({ dashboardLink, children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const isLogonUserChanged = useSelector(selectIsLogonUserChanged);
  const isConfigMissed = useSelector(getIsConfigMissed);
  const isOnline = useSelector(getNetworkStatus);

  const { navs, standaloneLayout } = qs.parse(location.search) || {};
  const showNavs = (navs ?? '1') === '1';
  const showSearchBar = standaloneLayout && location.pathname === Urls.FORM_EDITOR;
  const isRtlLanguage = useSelector(getIsRtlLanguage);
  const layoutClass = !showNavs
    ? classes.noNavs
    : isRtlLanguage
    ? classes.defaultRtl
    : classes.default;

  const { isMobileDevice } = useWindowDimensions();

  const isStandaloneLayout =
    [
      Urls.FORMS_LIST,
      Urls.ENTITIES_LIST,
      Urls.SMART_INSIGHT,
      Urls.REPORT_MODEL_DESIGNER,
      Urls.REPORT_DESIGNER,
      Urls.APP_MIGRATION_PAGE,
      Urls.CONFIGURE_DATA_SOURCE,
    ].includes(location.pathname) ||
    standaloneLayout ||
    !isOnline;

  useEffect(() => {
    if (isLogonUserChanged) {
      dispatch(updateLogonUser(false));
      history.replace(Urls.HOME);
    }
    dispatch(getSystemTranslations());
  }, [isLogonUserChanged]);

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.setAttribute('data-loaded', false);

    if (isConfigMissed) {
      dispatch(fetchAppConfigs());
      dispatch(getUserRolesAndRights());
    }
  }, [dispatch]);

  useEffect(() => {
    if (isRtlLanguage) {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    } else {
      document.getElementsByTagName('html')[0].removeAttribute('dir');
    }
  }, [isRtlLanguage]);

  useEffect(() => {
    pageLoadChecked = false;
    startTimer(PAGE_LOAD_TIMER);
  }, [location]);

  return (
    <>
      {isMobileDevice ? (
        <div className={classes.mobile}>
          {showNavs && <MobilePilgrimTopMenu />}
          <div className={classes.mobile}>{children}</div>
        </div>
      ) : isStandaloneLayout ? (
        <StandaloneLayout dashboardLink={dashboardLink ?? Urls.HOME} showSearchBar={showSearchBar}>
          {children}
        </StandaloneLayout>
      ) : (
        <div className={layoutClass}>
          {showNavs && <PilgrimTopMenu />}
          {showNavs && <Sidenav />}
          <div className={layoutClass}>{children}</div>
        </div>
      )}
    </>
  );
};

export default Layout;
